import { clsx } from 'clsx'
import { useContext, type ComponentPropsWithoutRef, type ReactElement } from 'react'

import type { TypeAlignmentEntry } from '@contentful-types/alignment'
import type { TypeComponentTitleDescriptionBlockEntry } from '@contentful-types/component-title-description-block'

import { AlignmentContext, DefaultAlignment } from '@contexts/alignment-context'
import { SectionContext } from '@contexts/section-context'

import { SingleColumnLayout } from '@components/layout/single-column/single-column'
import { TitleDescriptionBlock } from '@components/title-description-block/title-description-block'

import styles from './section-header.module.css'

interface SectionHeaderProps extends ComponentPropsWithoutRef<'div'> {
  heading?: TypeComponentTitleDescriptionBlockEntry
  alignment?: TypeAlignmentEntry
  titleTag?: 'h1' | 'h2'
}

export function SectionHeader({
  heading,
  alignment,
  titleTag,
  className,
  ...props
}: SectionHeaderProps): ReactElement | null {
  const { isHero, isH1Section } = useContext(SectionContext)

  // Determine the title tag based on context or prop
  const finalTitleTag = titleTag || (isHero ? 'h1' : isH1Section ? 'h1' : 'h2')

  if (!heading) {
    return null
  }

  return (
    <AlignmentContext.Provider value={alignment?.fields ?? DefaultAlignment}>
      <SingleColumnLayout className={clsx(className, styles.sectionHeaderSpacing)} {...props}>
        <TitleDescriptionBlock data={heading} titleTag={finalTitleTag} />
      </SingleColumnLayout>
    </AlignmentContext.Provider>
  )
}
